export type PartOfSpeech =
  | "noun"
  | "verb"
  | "adjective"
  | "adverb"
  | "pronoun"
  | "preposition"
  | "conjunction"
  | "phrase"
  | "other";

export type Gender = "masculine" | "feminine" | "neuter" | "plural" | null;

export type VerbForms = {
  infinitive: string;
  present3rdPerson?: string;
  preterite?: string;
  perfect?: string;
  imperative?: string;
};

export type ExamplePhrase = {
  de: string;
  explanation: string;
};

export type AnalysisResult = {
  query: string;
  displayedTerm: string;
  correctedQuery?: string | null;
  correctionNote?: string | null;
  lemma: string;
  partOfSpeech: PartOfSpeech;
  translation: string;
  shortMeaning: string;
  confidence: "high" | "medium" | "low";
  gender?: Gender;
  article?: string | null;
  plural?: string | null;
  nounCaseHint?: string | null;
  verbForms?: VerbForms | null;
  adjectiveForms?: string[] | null;
  grammarNotes: string[];
  examples: ExamplePhrase[];
  related: string[];
  source?: "ai" | "demo";
  debug?: ApiDebugInfo;
  modelUsed?: string;
  cacheHit?: boolean;
  cacheLayer?: "browser" | "edge";
  responseTimeMs?: number;
};

export type ApiDebugInfo = {
  code: string;
  message: string;
  details?: string;
  status?: number;
  model?: string;
  fallbackModels?: string[];
  attemptedModels?: Array<{
    model: string;
    ok: boolean;
    attempt?: number;
    latencyMs?: number;
    error?: string;
  }>;
  requestId?: string | null;
  aiBinding?: boolean;
  fallback?: AnalysisResult;
};

export class ApiDebugError extends Error {
  info: ApiDebugInfo;

  constructor(info: ApiDebugInfo) {
    super(info.message);
    this.name = "ApiDebugError";
    this.info = info;
  }
}
